import './index.less';

import Dynamic from './Dynamic.vue';

Dynamic.install = function install(Vue) {
  Vue.component(Dynamic.name, Dynamic);
};

export default Dynamic;
